import { DataBean } from "../DataBean";

export class AccountResume extends DataBean {


    public async getAccountResumeCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("TalentERP", "java.util.List_getAccountResumeCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

     public async getAccountResumeReport(page:any,Rows:any,props:any): Promise<any> {
        return this.getCustomService("TalentERP", "com.advantage.shared.Report_getAccountResumeReport_Number_Number_java.util.Map", [page,Rows,props]);
    }

    
}